import React, { useEffect, useState } from "react";
import { buildApiUrl } from "../config";  // ✅ Import config

const StudentQuickLinks = () => {
  const [quickLinks, setQuickLinks] = useState([]);

  useEffect(() => {
    fetch("/data/quick_links.json")
      .then((res) => res.json())
      .then((data) => setQuickLinks(data))
      .catch(() => setQuickLinks([]));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-indigo-700 mb-6 text-center">🌐 Student Quick Links</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {quickLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target={link.url.startsWith("http") ? "_blank" : "_self"}
              rel="noopener noreferrer"
              className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm hover:shadow-md hover:border-indigo-300 transition text-center"
            >
              <img
                src={link.image}
                alt={link.name}
                className="h-16 w-16 mx-auto mb-4 object-contain"
              />
              <h3 className="text-lg font-semibold text-indigo-700">{link.name}</h3>
              <p className="text-sm text-gray-500 mt-1">{link.description}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudentQuickLinks;
